import {
    ACTIVITY_CODE_GROUP_VALUE,
    GroupedOption,
    Option,
    secondaryGroupActivityCodeOption,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/PivotBoard/PivotBoard.types';

type ListTransformer = (groupListTransformer: readonly (GroupedOption | Option)[]) => (GroupedOption | Option)[];

const specialCaseTransformers: Record<string, ListTransformer> = {
    [ACTIVITY_CODE_GROUP_VALUE]: (list) =>
        list.map<GroupedOption | Option>((listItem) => {
            if ('options' in listItem) return listItem;
            if (listItem.value !== ACTIVITY_CODE_GROUP_VALUE) return listItem;
            return secondaryGroupActivityCodeOption;
        }),
};

// Remove primary selection option so the user won't be able to select the same option twice
// In case the user selects "activityCodeValueGroup" as primary selection then instead of removing this option
// we need to replace this option with
export const getSecondaryGroupedOptionList = (
    primaryGroupSelected: ISelectOption<string>,
    list: readonly (GroupedOption | Option)[],
): (GroupedOption | Option)[] => {
    const primarySelectedValue = primaryGroupSelected.value;

    const specialCaseTransformer = specialCaseTransformers[primarySelectedValue];

    if (specialCaseTransformer) return specialCaseTransformer(list);
    return list.reduce<(GroupedOption | Option)[]>((acc, listItem) => {
        if ('options' in listItem) {
            acc.push({
                ...listItem,
                options: listItem.options.filter((option) => option.value !== primarySelectedValue),
            });
        } else if (listItem.value !== primarySelectedValue) {
            acc.push(listItem);
        }
        return acc;
    }, []);
};
